import { useEffect } from 'react';
import { useQuery } from 'react-fetching-library';
import { useDispatch, useSelector } from 'react-redux';

import selectors from '../../store/selectors';

const fetchAccountOptions = accountId => ({
  method: 'GET',
  endpoint: `/api/donate/accounts/${accountId}/options`,
});

const actions = {
  loading: () => ({
    type: 'fetch/account-options/loading',
  }),
  finished: () => ({
    type: 'fetch/account-options/finished',
  }),
  fail: error => ({
    type: 'fetch/account-options/fail',
    payload: error,
  }),
  saveData: payload => ({
    type: 'account-options/saveData',
    payload,
  }),
};

export const useFetchAccountOptions = () => {
  const accountId = useSelector(selectors.getAccountId);

  const { loading, payload, error } = useQuery(fetchAccountOptions(accountId));
  const dispatch = useDispatch();

  useEffect(() => {
    if (loading) {
      dispatch(actions.loading());
    } else if (error) {
      dispatch(actions.fail(error));
    } else {
      dispatch(actions.finished());
      dispatch(actions.saveData(payload));
    }
  }, [loading, error, payload]);

  return loading;
};
